<template>
  <div class="test-page-wrapper">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <span class="breadcrumb-item clickable" @click="goHome">真题汇总</span>
      <span v-if="breadcrumbPath" class="breadcrumb-separator">></span>
      <span v-if="breadcrumbPath" class="breadcrumb-item active">{{
        breadcrumbPath
      }}</span>
      <span
        v-if="isEditingAnswer && selectedQuestionNum"
        class="breadcrumb-separator"
        >></span
      >
      <span
        v-if="isEditingAnswer && selectedQuestionNum"
        class="breadcrumb-item active"
      >
        第{{ selectedQuestionNum }}题
      </span>
    </div>

    <!-- 主要内容区域 -->
    <div v-if="!isEditingAnswer" class="main-content">
      <div id="testChoice">
        <div class="tab-container">
          <div
            v-for="exam in examTypes"
            :key="exam.value"
            class="tab-item"
            :class="{ active: paperSelect.testType === exam.value }"
            @click="selectExamType(exam.value)"
          >
            {{ exam.label }}
          </div>
        </div>
        <div class="order-tabs-wrapper" v-if="testOrderList.length > 0">
          <div class="tab-container order-tabs">
            <div
              v-for="orderItem in testOrderList"
              :key="orderItem.testOrder"
              class="tab-item"
              :class="{ active: selectedTestOrder === orderItem.testOrder }"
              @click="selectTestOrder(orderItem.testOrder)"
            >
              {{ getOrderDisplayName(orderItem.testOrder) }}
            </div>
          </div>
          <div class="header-right">
            <button class="primary-button" @click="addTest()">新增考试</button>
          </div>
        </div>
      </div>

      <div id="test">
        <!-- <div v-if="Object.keys(groupedPapers).length === 0" class="no-data">
          暂无试卷数据
        </div> -->
        <div
          v-for="(group, testName) in groupedPapers"
          :key="testName"
          class="test-group"
        >
          <div class="test-group-header">
            <div class="header-left">
              <h3>{{ testName }}</h3>
              <span class="paper-count"
                >{{ getRealPaperCount(group) }}套试卷</span
              >
            </div>
            <div class="header-right">
              <button
                v-if="shouldShowAddButton(group)"
                class="primary-button"
                @click="addPaper(testName, getTestIdByName(testName))"
              >
                添加试卷
              </button>
            </div>
          </div>
          <table class="data-table">
            <thead>
              <tr>
                <th>paperId</th>
                <th>题型</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in group" :key="row.paperId || row.testName">
                <td>{{ row.paperId || "-" }}</td>
                <td>
                  <span v-if="row.isEmpty" class="empty-paper">{{
                    row.paperType
                  }}</span>
                  <span v-else
                    >Part{{ row.paperIndex }} {{ row.paperType }}</span
                  >
                </td>
                <td>
                  <button
                    v-if="!row.isEmpty"
                    class="icon-button"
                    @click="updatePaper(row.paperId)"
                    title="修改"
                  >
                    ✏️
                  </button>
                  <button
                    v-if="!row.isEmpty"
                    class="icon-button"
                    @click="
                      editAnswer(row.paperId, row.testName, row.paperIndex, row)
                    "
                    title="编辑答案"
                  >
                    📋
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- 编辑答案区域 -->
    <div v-else class="edit-answer-area">
      <div class="answer-layout">
        <!-- 左侧：试卷信息 -->
        <div class="left-panel">
          <div class="panel-header">
            <h3>试卷内容</h3>
          </div>
          <div class="panel-content">
            <div class="paper-info">
              <p>
                <strong>考试类型：</strong
                >{{ currentTestType ? currentTestType.testTypeInfo : "" }}
              </p>
              <p>
                <strong>总题数：</strong
                >{{
                  paperDetails
                    ? paperDetails.totalScore
                    : currentPaper
                    ? currentPaper.totalScore || 40
                    : 40
                }}题
              </p>
              <p>
                <strong>试卷类型：</strong
                >{{ currentPaper ? currentPaper.paperType || "未知" : "未知" }}
              </p>
              <p>
                <strong>试卷ID：</strong
                >{{ currentPaper ? currentPaper.paperId : "" }}
              </p>
            </div>

            <!-- 试卷题目内容 -->
            <div
              class="paper-content"
              v-if="questionList && questionList.length > 0"
            >
              <h4>题目内容</h4>
              <div
                v-for="(question, index) in questionList"
                :key="question.questionId"
                class="question-item"
              >
                <div class="question-header">
                  <span class="question-title">题目 {{ index + 1 }}</span>
                  <div class="question-actions">
                    <span class="question-type-badge">{{
                      getQuestionTypeText(question.questionType)
                    }}</span>
                    <button
                      class="edit-question-btn"
                      @click="startEditQuestion(question)"
                      :disabled="isSavingQuestion"
                    >
                      {{
                        editingQuestionId === question.questionId
                          ? "取消编辑"
                          : "编辑题目"
                      }}
                    </button>
                    <button
                      class="edit-answer-btn"
                      @click="openEditAnswerDialog(question)"
                    >
                      编辑答案
                    </button>
                  </div>
                </div>

                <!-- 编辑题目模式 -->
                <div
                  v-if="editingQuestionId === question.questionId"
                  class="edit-question-section"
                >
                  <div class="edit-question-header">
                    <h4>编辑题目</h4>
                  </div>
                  <div class="edit-question-content">
                    <div class="question-type-edit">
                      <label>题目类型：</label>
                      <div class="question-type-buttons">
                        <button
                          class="type-btn"
                          :class="{ active: editingQuestionType === '1' }"
                          @click="editingQuestionType = '1'"
                        >
                          单选
                        </button>
                        <button
                          class="type-btn"
                          :class="{ active: editingQuestionType === '2' }"
                          @click="editingQuestionType = '2'"
                        >
                          多选
                        </button>
                        <button
                          class="type-btn"
                          :class="{ active: editingQuestionType === '0' }"
                          @click="editingQuestionType = '0'"
                        >
                          填空
                        </button>
                      </div>
                    </div>
                    <div class="question-content-edit">
                      <label>题目内容</label>
                      <textarea
                        v-model="editingQuestionStem"
                        placeholder="请输入题目内容（支持HTML标签）..."
                        class="stem-edit-input"
                        rows="8"
                      ></textarea>
                    </div>
                    <div class="edit-question-actions">
                      <button
                        class="save-question-btn"
                        @click="saveQuestion(question.questionId)"
                        :disabled="isSavingQuestion"
                      >
                        {{ isSavingQuestion ? "保存中..." : "保存题目" }}
                      </button>
                      <button
                        class="cancel-edit-btn"
                        @click="cancelEditQuestion"
                        :disabled="isSavingQuestion"
                      >
                        取消
                      </button>
                    </div>
                  </div>
                </div>

                <!-- 正常显示模式 -->
                <div v-else class="stem-content" v-html="question.stem"></div>
              </div>
            </div>

            <!-- 无题目时显示添加题目表格 -->

            <div class="questions-table">
              <div
                v-for="(question, index) in newQuestions"
                :key="index"
                class="question-card"
              >
                <div class="question-header">
                  <div class="question-type-buttons">
                    <button
                      class="type-btn"
                      :class="{ active: question.questionType === '1' }"
                      @click="question.questionType = '1'"
                    >
                      单选
                    </button>
                    <button
                      class="type-btn"
                      :class="{ active: question.questionType === '2' }"
                      @click="question.questionType = '2'"
                    >
                      多选
                    </button>
                    <button
                      class="type-btn"
                      :class="{ active: question.questionType === '0' }"
                      @click="question.questionType = '0'"
                    >
                      填空
                    </button>
                  </div>
                  <button class="delete-btn" @click="deleteQuestion(index)">
                    删除
                  </button>
                </div>
                <div class="question-content-wrapper">
                  <div class="content-label">题目内容</div>
                  <textarea
                    v-model="question.stem"
                    placeholder="请输入题目内容..."
                    class="stem-input"
                    rows="4"
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="add-questions-header">
              <button class="add-question-btn" @click="addNewQuestion">
                + 新增题目
              </button>
            </div>

            <div class="submit-section" v-if="newQuestions.length > 0">
              <button
                class="submit-btn"
                @click="submitQuestions"
                :disabled="isSubmittingQuestions"
              >
                {{ isSubmittingQuestions ? "提交中..." : "提交所有题目" }}
              </button>
              <button
                class="cancel-btn"
                @click="cancelQuestions"
                :disabled="isSubmittingQuestions"
              >
                取消
              </button>
            </div>
          </div>
        </div>

        <!-- 中间：题号列表 -->
        <div class="middle-panel">
          <div class="panel-header">
            <h3>题号</h3>
          </div>
          <div class="panel-content">
            <div class="question-numbers">
              <div
                v-for="num in getQuestionNumbers()"
                :key="num"
                class="question-number"
                :class="{ active: selectedQuestionNum === num }"
                @click="selectQuestion(num)"
              >
                {{ num }}
              </div>
            </div>
          </div>
        </div>

        <!-- 右侧：题目详情 -->
        <div class="right-panel">
          <div class="panel-header">
            <h3>题目详情</h3>
          </div>
          <div class="panel-content">
            <div
              v-if="selectedQuestionNum && getCurrentQuestion()"
              class="question-detail"
            >
              <!-- 选择题选项显示 (单选题、多选题) -->
              <div
                class="options-section"
                v-if="isChoiceQuestion(getCurrentQuestion().questionType)"
              >
                <h4>选项</h4>
                <div class="options-list">
                  <div
                    v-for="(option, index) in getCurrentQuestion().answerList"
                    :key="index"
                    class="option-item"
                    :class="{ correct: isCorrectOption(option.answer) }"
                  >
                    <span class="option-label"
                      >{{ getOptionLabel(index) }}.</span
                    >
                    <span class="option-text">{{ option.answer }}</span>
                    <span
                      v-if="isCorrectOption(option.answer)"
                      class="correct-mark"
                      >✓</span
                    >
                  </div>
                </div>
              </div>

              <!-- 填空题答案显示 -->
              <div
                class="answer-section"
                v-if="getCurrentQuestion().questionType === 0"
              >
                <h4>正确答案</h4>
                <div class="single-answer">
                  <div class="answer-item">
                    <span class="answer-number"
                      >{{ selectedQuestionNum }}.</span
                    >
                    <span class="answer-text">{{
                      getCurrentQuestionAnswer()
                    }}</span>
                  </div>
                </div>
              </div>

              <div class="explanation-section">
                <div class="explanation-header">
                  <h4>解析</h4>
                  <button
                    v-if="getCurrentQuestion()"
                    class="edit-explanation-btn"
                    @click="toggleEditExplanation"
                    :disabled="isSavingExplanation"
                  >
                    {{ isEditingExplanation ? "取消编辑" : "编辑解析" }}
                  </button>
                </div>
                <div class="explanation-content">
                  <p>
                    题目类型：{{
                      getQuestionTypeText(getCurrentQuestion().questionType)
                    }}
                  </p>

                  <!-- 编辑模式 -->
                  <div v-if="isEditingExplanation" class="explanation-edit">
                    <div class="edit-label">编辑解析内容：</div>
                    <textarea
                      v-model="editingExplanationText"
                      class="explanation-textarea"
                      rows="8"
                      placeholder="请输入解析内容..."
                    ></textarea>
                    <div class="edit-actions">
                      <button
                        class="save-explanation-btn"
                        @click="saveExplanation"
                        :disabled="isSavingExplanation"
                      >
                        {{ isSavingExplanation ? "保存中..." : "保存解析" }}
                      </button>
                    </div>
                  </div>

                  <!-- 显示模式 -->
                  <div v-else>
                    <div
                      v-if="getCurrentQuestionExplanation()"
                      class="explanation-detail"
                      v-html="getCurrentQuestionExplanation()"
                    ></div>
                    <div v-else class="no-explanation">
                      <p>暂无解析内容</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="no-question-selected">
              <p>请从左侧选择题号来查看题目详情</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 新增考试弹窗组件 -->
  <AddTestDialog
    :visible="showAddDialog"
    :examTypes="examTypes"
    :defaultTestType="
      currentTestType ? currentTestType.testType : paperSelect.testType || ''
    "
    @close="closeDialog"
    @submit="submitForm"
  />

  <!-- 新增试卷弹窗组件 -->
  <AddPaperDialog
    :visible="showAddPaperDialog"
    :testName="currentTestName"
    :testId="currentTestId"
    :testType="currentTestType ? currentTestType.testTypeInfo : ''"
    @close="closePaperDialog"
    @submit="submitPaperForm"
  />

  <!-- 编辑答案弹窗 -->
  <div
    class="edit-answer-dialog-overlay"
    v-if="showEditAnswerDialog"
    @click="closeEditAnswerDialog"
  >
    <div class="edit-answer-dialog" @click.stop>
      <div class="dialog-header">
        <h3>编辑答案</h3>
        <button class="close-btn" @click="closeEditAnswerDialog">×</button>
      </div>
      <div class="dialog-content">
        <div class="question-info">
          <p>
            <strong>题目类型：</strong
            >{{
              editingQuestion
                ? getQuestionTypeText(editingQuestion.questionType)
                : ""
            }}
          </p>
          <p>
            <strong>题目ID：</strong
            >{{ editingQuestion ? editingQuestion.questionId : "" }}
          </p>
        </div>

        <!-- 题目内容显示 -->
        <div class="question-stem-display" v-if="editingQuestion">
          <div class="stem-header">
            <h4>题目内容</h4>
          </div>
          <div class="stem-content-display" v-html="editingQuestion.stem"></div>
        </div>

        <!-- 选择题编辑 -->
        <div
          v-if="
            editingQuestion &&
            (editingQuestion.questionType === 2 ||
              editingQuestion.questionType === 1)
          "
          class="choice-edit"
        >
          <div class="section-header">
            <h4>选项编辑</h4>
            <button class="add-answer-btn" @click="addChoiceOption">
              + 新增选项
            </button>
          </div>
          <div class="choice-options">
            <div
              v-for="(option, index) in editingAnswers"
              :key="option.answerId || `new-${index}`"
              class="choice-option"
            >
              <div class="option-row">
                <div class="option-label-container">
                  <span class="option-label">{{ getOptionLabel(index) }}</span>
                </div>
                <div class="option-input-container">
                  <input
                    type="text"
                    v-model="option.answer"
                    class="option-input"
                    :placeholder="`选项${getOptionLabel(index)}`"
                  />
                </div>
                <div class="option-controls">
                  <label class="correct-checkbox">
                    <input
                      type="checkbox"
                      v-model="option.ifRight"
                      :true-value="1"
                      :false-value="0"
                    />
                    <span class="checkbox-label">正确</span>
                  </label>
                  <button
                    class="delete-answer-btn"
                    @click="deleteAnswer(index)"
                    :disabled="editingAnswers.length <= 1"
                    title="删除选项"
                  >
                    —
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 填空题编辑 -->
        <div
          v-if="editingQuestion && editingQuestion.questionType === 0"
          class="blank-edit"
        >
          <div class="section-header">
            <h4>填空答案编辑</h4>
            <button class="add-answer-btn" @click="addBlankAnswer">
              + 新增答案
            </button>
          </div>
          <div class="blank-answers">
            <div
              v-for="(answer, index) in editingAnswers"
              :key="answer.answerId || `new-${index}`"
              class="blank-answer"
            >
              <div class="answer-row">
                <div class="answer-label-container">
                  <span class="answer-label">{{ index + 1 }}</span>
                </div>
                <div class="answer-input-container">
                  <input
                    type="text"
                    v-model="answer.answer"
                    class="answer-input"
                    :placeholder="`答案${index + 1}`"
                  />
                </div>
                <div class="answer-controls">
                  <button
                    class="delete-answer-btn"
                    @click="deleteAnswer(index)"
                    :disabled="editingAnswers.length <= 1"
                    title="删除答案"
                  >
                    -
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-actions">
        <button
          class="save-btn"
          @click="saveAnswers"
          :disabled="isSavingAnswers"
        >
          {{ isSavingAnswers ? "保存中..." : "保存" }}
        </button>
        <button
          class="cancel-btn"
          @click="closeEditAnswerDialog"
          :disabled="isSavingAnswers"
        >
          取消
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { test, paper, question, answer } from "../../../api/index";
import AddTestDialog from "../../components/AddTestDialog.vue";
import AddPaperDialog from "../../components/AddPaperDialog.vue";

export default {
  components: {
    AddTestDialog,
    AddPaperDialog,
  },
  data() {
    return {
      paperSelect: {
        testType: "",
        testOrder: "",
      },
      paperList: [],
      examTypes: [], // 从API获取
      allTestData: [], // 存储完整的考试数据
      testOrderList: [], // 当前考试类型下的testOrder列表
      selectedTestOrder: null, // 当前选中的testOrder
      currentTestType: null, // 当前选中的考试类型
      showAddDialog: false, // 控制弹窗显示
      showAddPaperDialog: false, // 控制添加试卷弹窗显示
      currentTestName: "", // 当前选中的考试名称
      currentTestId: null, // 当前选中的考试ID
      breadcrumbPath: "", // 面包屑路径
      isEditingAnswer: false, // 是否在编辑答案模式
      selectedQuestionNum: null, // 当前选中的题号
      currentPaper: null, // 当前编辑的试卷信息
      questionList: [], // 题目列表
      paperDetails: null, // 试卷详细信息（从API获取）
      newQuestions: [], // 新增的题目列表
      isEditingExplanation: false, // 是否在编辑解析模式
      editingExplanationText: "", // 编辑中的解析文本
      // 编辑答案弹窗相关
      showEditAnswerDialog: false, // 控制编辑答案弹窗显示
      editingQuestion: null, // 正在编辑的题目对象
      editingAnswers: [], // 编辑中的答案列表
      isSavingAnswers: false, // 控制保存答案的loading状态
      isSubmittingQuestions: false, // 控制提交新增题目的loading状态
      isSavingExplanation: false, // 控制保存解析的loading状态
      // 编辑题目相关
      editingQuestionId: null, // 当前编辑的题目ID
      editingQuestionType: "", // 编辑中的题目类型
      editingQuestionStem: "", // 编辑中的题目内容
      isSavingQuestion: false, // 控制保存题目的loading状态
    };
  },
  mounted() {
    test
      .getAlTests()
      .then((res) => {
        if (res.code === 200) {
          // 存储完整数据
          this.allTestData = res.data;

          // 从返回数据中提取考试类型
          this.examTypes = res.data.map((item) => ({
            value: item.testType,
            label: item.testTypeInfo,
          }));

          // 设置默认选中第一个考试类型
          if (this.examTypes.length > 0) {
            this.paperSelect.testType = this.examTypes[0].value;
            this.loadTestData(this.examTypes[0].value);
          }
        } else {
          console.error("获取考试列表失败:", res.msg);
          this.examTypes = [];
          this.allTestData = [];
        }
      })
      .catch((error) => {
        console.error("API调用失败:", error);

        // 额外检查：如果是认证错误，确保跳转到登录页
        if (
          error.message &&
          (error.message.includes("token") || error.message.includes("登录"))
        ) {
          localStorage.removeItem("m-token");
          localStorage.removeItem("userInfo");
          this.$router.push("/login");
          return;
        }

        this.examTypes = [];
        this.allTestData = [];
      });
  },
  computed: {
    groupedPapers() {
      const groups = {};
      this.paperList.forEach((paper) => {
        if (!groups[paper.testName]) {
          groups[paper.testName] = [];
        }
        groups[paper.testName].push(paper);
      });
      return groups;
    },
  },
  methods: {
    getRealPaperCount(group) {
      // 计算真实的试卷数量，过滤掉空占位符
      return group.filter((paper) => !paper.isEmpty).length;
    },
    shouldShowAddButton(group) {
      // 判断是否应该显示添加试卷按钮
      if (!this.currentTestType) return false;

      const realPaperCount = this.getRealPaperCount(group);
      const testType = this.currentTestType.testType;

      // 雅思：最多4套试卷
      if (testType === 0) {
        return realPaperCount < 4;
      }
      // 四级、六级：最多3套试卷
      else if (testType === 1 || testType === 2) {
        return realPaperCount < 3;
      }

      return true;
    },
    addTest() {
      // 显示新增考试弹窗
      this.showAddDialog = true;
    },
    addPaper(testName, testId) {
      // 显示新增试卷弹窗
      this.currentTestName = testName;
      this.currentTestId = testId;
      this.showAddPaperDialog = true;
    },
    getTestIdByName(testName) {
      // 从原始数据中根据 testName 获取 testId
      if (this.selectedTestOrder && this.testOrderList.length > 0) {
        const orderData = this.testOrderList.find(
          (item) => item.testOrder === this.selectedTestOrder
        );
        if (orderData && orderData.testDTOs) {
          const test = orderData.testDTOs.find(
            (test) => test.testName === testName
          );
          return test ? test.testId : null;
        }
      }
      return null;
    },

    closeDialog() {
      this.showAddDialog = false;
    },
    closePaperDialog() {
      this.showAddPaperDialog = false;
    },
    submitForm(formData) {
      // 这里可以添加API调用来创建新考试
      test
        .addTest(formData)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(`成功创建考试：${formData.testName}`);
            // 关闭弹窗
            this.closeDialog();
            // 刷新数据
            this.refreshData();
          } else {
            this.$message.error(`创建考试失败：${res.msg}`);
          }
        })
        .catch((error) => {
          this.$message.error("网络错误，请检查网络连接");
          console.error("API调用失败:", error);
        });
    },
    submitPaperForm(formData) {
      // 这里可以添加API调用来创建新试卷
      paper
        .addPaper(formData)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(`成功创建试卷：${formData.paperType}`);
            this.closePaperDialog();
            // 刷新数据
            this.refreshData();
          } else {
            this.$message.error(`创建试卷失败：${res.msg}`);
          }
        })
        .catch((error) => {
          this.$message.error("网络错误，请检查网络连接");
          console.error("API调用失败:", error);
        });
    },
    refreshData() {
      // 重新获取完整数据并刷新当前视图
      test
        .getAlTests()
        .then((res) => {
          if (res.code === 200) {
            // 更新完整数据
            this.allTestData = res.data;

            // 更新考试类型列表
            this.examTypes = res.data.map((item) => ({
              value: item.testType,
              label: item.testTypeInfo,
            }));

            // 刷新当前选中的考试类型数据
            if (this.paperSelect.testType !== "") {
              this.loadTestData(this.paperSelect.testType);
            }
          } else {
            this.$message.error("刷新数据失败");
          }
        })
        .catch((error) => {
          this.$message.error("刷新数据失败，请检查网络连接");
          console.error("刷新数据失败:", error);
        });
    },
    updatePaper(paperId) {
      // 修改试卷的逻辑
      // 这里可以添加修改试卷的API调用
      // TODO: 实现修改试卷逻辑
      if (paperId) {
        // 添加修改逻辑
      }
    },
    editAnswer(paperId, testName, paperIndex, paperInfo) {
      // 编辑答案的逻辑
      // 更新面包屑路径
      this.breadcrumbPath = `${testName} Part ${paperIndex}`;

      // 存储当前试卷信息
      this.currentPaper = paperInfo;

      // 切换到编辑答案模式
      this.isEditingAnswer = true;

      // 清空新增题目数组
      this.newQuestions = [];

      // 获取题目数据
      question
        .showQuestions(paperId)
        .then((res) => {
          if (res.code === 200) {
            console.log("题目数据:", res.data);
            this.paperDetails = res.data;
            this.questionList = res.data.questionDTOs || [];

            // 更新试卷信息
            this.currentPaper = {
              ...this.currentPaper,
              totalScore: res.data.totalScore,
              setOff: res.data.setOff,
            };

            // 默认选中第一题（从setOff+1开始）
            this.selectedQuestionNum = (res.data.setOff || 0) + 1;
          } else {
            this.$message.error("获取题目数据失败");
          }
        })
        .catch((error) => {
          console.error("获取题目数据失败:", error);
          this.$message.error("获取题目数据失败");
        });
    },
    goHome() {
      // 返回主页面，清空面包屑路径
      this.breadcrumbPath = "";

      // 退出编辑答案模式
      this.isEditingAnswer = false;

      // 退出编辑解析模式
      this.cancelEditExplanation();

      // 清空选中的题号
      this.selectedQuestionNum = null;

      // 清空当前试卷信息
      this.currentPaper = null;

      // 清空题目数据
      this.questionList = [];
      this.paperDetails = null;

      // 清空新增题目数组
      this.newQuestions = [];

      // 重置提交状态
      this.isSubmittingQuestions = false;
      this.isSavingAnswers = false;
      this.isSavingExplanation = false;
      this.isSavingQuestion = false;

      // 重置编辑题目状态
      this.editingQuestionId = null;
      this.editingQuestionType = "";
      this.editingQuestionStem = "";

      // 这里可以添加其他返回主页面的逻辑
      // 比如清空某些选择状态或重置某些数据
    },
    selectQuestion(questionNum) {
      // 选择题号
      this.selectedQuestionNum = questionNum;

      // 切换题目时退出编辑模式
      this.cancelEditExplanation();

      // 这里可以添加API调用来获取题目详情
      // TODO: 根据题号加载题目内容
      // 临时示例：根据题号生成不同的示例内容
      console.log(`选择了题目 ${questionNum}`);
    },
    getQuestionNumbers() {
      // 生成题号列表，从setOff+1开始
      if (!this.paperDetails) {
        return Array.from({ length: 0 }, (_, i) => i + 1);
      }

      const totalScore = this.paperDetails.totalScore;
      const setOff = this.paperDetails.setOff || 0;

      return Array.from({ length: totalScore }, (_, i) => setOff + i + 1);
    },
    getCurrentQuestion() {
      // 获取当前选中题号对应的题目数据
      if (
        !this.questionList ||
        this.questionList.length === 0 ||
        !this.selectedQuestionNum
      ) {
        return null;
      }

      const currentQuestionNum = this.selectedQuestionNum;

      // 遍历题目列表，找到包含当前题号的题目
      for (let i = 0; i < this.questionList.length; i++) {
        const question = this.questionList[i];

        // 根据题目类型判断题目范围
        if (question.questionType === 0) {
          // 填空题：检查是否在该题目的答案范围内
          const questionStartNum = this.getQuestionStartNumber(i);
          const questionEndNum =
            questionStartNum +
            (question.rightAnswer ? question.rightAnswer.length : 1) -
            1;

          if (
            currentQuestionNum >= questionStartNum &&
            currentQuestionNum <= questionEndNum
          ) {
            return question;
          }
        } else if (question.questionType === 2) {
          // 多选题：检查是否在该题目的范围内
          const questionStartNum = this.getQuestionStartNumber(i);
          let questionEndNum = questionStartNum;

          // 检查stem中是否包含"Questions X and Y"的模式
          const questionsMatch = question.stem.match(
            /Questions\s+(\d+)\s+and\s+(\d+)/i
          );
          if (questionsMatch) {
            const startQ = parseInt(questionsMatch[1]);
            const endQ = parseInt(questionsMatch[2]);
            questionEndNum = questionStartNum + (endQ - startQ);
          } else {
            // 如果没有明确的题号范围，根据答案数量判断
            questionEndNum =
              questionStartNum +
              (question.rightAnswer ? question.rightAnswer.length : 1) -
              1;
          }

          if (
            currentQuestionNum >= questionStartNum &&
            currentQuestionNum <= questionEndNum
          ) {
            return question;
          }
        } else {
          // 单选题：检查是否是对应的题号
          const questionNum = this.getQuestionStartNumber(i);
          if (currentQuestionNum === questionNum) {
            return question;
          }
        }
      }

      return null;
    },
    getQuestionStartNumber(questionIndex) {
      // 计算指定题目的起始编号
      const setOff = this.paperDetails ? this.paperDetails.setOff || 0 : 0;
      let startNum = setOff + 1;

      // 遍历之前的题目，累计题目数量
      for (let i = 0; i < questionIndex; i++) {
        const question = this.questionList[i];
        if (question.questionType === 0) {
          // 填空题：根据答案数量计算占用的题号数
          startNum += question.rightAnswer ? question.rightAnswer.length : 1;
        } else if (question.questionType === 2) {
          // 多选题：根据题目描述或答案数量计算占用的题号数
          // 检查stem中是否包含"Questions X and Y"的模式
          const questionsMatch = question.stem.match(
            /Questions\s+(\d+)\s+and\s+(\d+)/i
          );
          if (questionsMatch) {
            const startQ = parseInt(questionsMatch[1]);
            const endQ = parseInt(questionsMatch[2]);
            startNum += endQ - startQ + 1;
          } else {
            // 如果没有明确的题号范围，根据答案数量判断
            startNum += question.rightAnswer ? question.rightAnswer.length : 1;
          }
        } else {
          // 单选题：占用1个题号
          startNum += 1;
        }
      }

      return startNum;
    },
    getAnswerNumber(index) {
      // 获取答案序号，从setOff+1开始
      const setOff = this.paperDetails ? this.paperDetails.setOff || 0 : 0;
      return setOff + index + 1;
    },
    getQuestionTypeText(questionType) {
      // 根据题目类型返回文本描述
      const types = {
        2: "多选题",
        1: "单选题",
        0: "填空题",
      };
      return types[questionType] || "未知类型";
    },
    isChoiceQuestion(questionType) {
      // 判断是否为选择题（单选或多选）
      return questionType === 2 || questionType === 1;
    },
    isCorrectOption(optionAnswer) {
      // 判断选项是否为正确答案
      const currentQuestion = this.getCurrentQuestion();
      if (!currentQuestion || !currentQuestion.answerList) {
        return false;
      }

      // 根据选项的答案文本找到对应的选项对象，检查其ifRight字段
      const option = currentQuestion.answerList.find(
        (item) => item.answer === optionAnswer
      );

      return option && option.ifRight === 1;
    },
    getOptionLabel(index) {
      // 获取选项标签 A, B, C, D...
      return String.fromCharCode(65 + index); // A=65
    },
    getCurrentQuestionAnswer() {
      // 获取当前选中题号对应的答案
      const currentQuestion = this.getCurrentQuestion();
      if (
        !currentQuestion ||
        !currentQuestion.rightAnswer ||
        !this.selectedQuestionNum
      ) {
        return "暂无答案";
      }

      // 对于单选题，直接返回答案
      if (currentQuestion.questionType === 1) {
        return currentQuestion.rightAnswer[0] || "暂无答案";
      }

      // 对于多选题，显示所有答案（无论点击哪个题号）
      if (currentQuestion.questionType === 2) {
        return currentQuestion.rightAnswer.join(", ");
      }

      // 对于填空题，根据题号返回对应答案
      if (currentQuestion.questionType === 0) {
        const questionIndex = this.questionList.findIndex(
          (q) => q.questionId === currentQuestion.questionId
        );
        if (questionIndex === -1) {
          return "暂无答案";
        }

        // 计算当前题目的起始编号
        const questionStartNum = this.getQuestionStartNumber(questionIndex);

        // 计算答案索引
        const answerIndex = this.selectedQuestionNum - questionStartNum;

        // 根据索引返回对应答案
        if (
          answerIndex >= 0 &&
          answerIndex < currentQuestion.rightAnswer.length
        ) {
          return currentQuestion.rightAnswer[answerIndex];
        }
      }

      return "暂无答案";
    },
    getCurrentQuestionExplanation() {
      // 获取当前选中题号对应的解析
      const currentQuestion = this.getCurrentQuestion();
      if (!currentQuestion || !this.selectedQuestionNum) {
        return null;
      }

      // 对于选择题（单选和多选），从answerList中获取正确答案的解析
      if (
        currentQuestion.questionType === 2 ||
        currentQuestion.questionType === 1
      ) {
        if (!currentQuestion.answerList) {
          return null;
        }

        // 找到正确答案的解析
        const correctAnswer = currentQuestion.answerList.find(
          (item) => item.ifRight === 1
        );

        if (correctAnswer && correctAnswer.explain) {
          return correctAnswer.explain;
        }
      }

      // 对于填空题，根据题号在填空题中的位置来获取对应的解析
      if (currentQuestion.questionType === 0) {
        if (!currentQuestion.answerList) {
          return null;
        }

        // 找到当前题目在题目列表中的索引
        const questionIndex = this.questionList.findIndex(
          (q) => q.questionId === currentQuestion.questionId
        );
        if (questionIndex === -1) {
          return null;
        }

        // 计算当前题目的起始编号
        const questionStartNum = this.getQuestionStartNumber(questionIndex);

        // 计算当前题号在该填空题中的位置索引
        const answerIndex = this.selectedQuestionNum - questionStartNum;

        // 根据位置索引获取对应的解析
        if (
          answerIndex >= 0 &&
          answerIndex < currentQuestion.answerList.length
        ) {
          const answerItem = currentQuestion.answerList[answerIndex];
          if (answerItem && answerItem.explain) {
            return answerItem.explain;
          }
        }
      }

      // 返回题目级别的解析作为备选
      return currentQuestion.explain || null;
    },
    selectExamType(value) {
      this.paperSelect.testType = value;
      this.loadTestData(value);
      // 清空面包屑路径
      this.breadcrumbPath = "";
      // 退出编辑答案模式
      this.isEditingAnswer = false;
      // 退出编辑解析模式
      this.cancelEditExplanation();
      // 清空选中的题号
      this.selectedQuestionNum = null;
      // 清空当前试卷信息
      this.currentPaper = null;
      // 清空题目数据
      this.questionList = [];
      this.paperDetails = null;
      // 清空新增题目数组
      this.newQuestions = [];
      // 重置提交状态
      this.isSubmittingQuestions = false;
      this.isSavingAnswers = false;
      this.isSavingExplanation = false;
      this.isSavingQuestion = false;

      // 重置编辑题目状态
      this.editingQuestionId = null;
      this.editingQuestionType = "";
      this.editingQuestionStem = "";
    },
    loadTestData(testType) {
      // 从完整数据中筛选出对应考试类型的数据
      const selectedTestType = this.allTestData.find(
        (item) => item.testType === testType
      );
      if (selectedTestType) {
        this.currentTestType = selectedTestType;

        // 获取testOrder列表
        this.testOrderList = selectedTestType.testOrderDTOs;

        // 默认选中第一个testOrder
        if (this.testOrderList.length > 0) {
          this.selectedTestOrder = this.testOrderList[0].testOrder;
          this.loadTestOrderData(this.testOrderList[0]);
        } else {
          this.paperList = [];
        }
      }
    },
    selectTestOrder(testOrder) {
      this.selectedTestOrder = testOrder;
      const orderData = this.testOrderList.find(
        (item) => item.testOrder === testOrder
      );
      if (orderData) {
        this.loadTestOrderData(orderData);
      }
      // 清空面包屑路径
      this.breadcrumbPath = "";
      // 退出编辑答案模式
      this.isEditingAnswer = false;
      // 退出编辑解析模式
      this.cancelEditExplanation();
      // 清空选中的题号
      this.selectedQuestionNum = null;
      // 清空当前试卷信息
      this.currentPaper = null;
      // 清空题目数据
      this.questionList = [];
      this.paperDetails = null;
      // 清空新增题目数组
      this.newQuestions = [];
      // 重置提交状态
      this.isSubmittingQuestions = false;
      this.isSavingAnswers = false;
      this.isSavingExplanation = false;
      this.isSavingQuestion = false;

      // 重置编辑题目状态
      this.editingQuestionId = null;
      this.editingQuestionType = "";
      this.editingQuestionStem = "";
    },
    loadTestOrderData(orderData) {
      // 获取该testOrder下的所有试卷数据
      this.paperList = [];
      orderData.testDTOs.forEach((test) => {
        if (test.paperDTO && test.paperDTO.length > 0) {
          // 有试卷数据的考试
          test.paperDTO.forEach((paper) => {
            this.paperList.push({
              ...paper,
              testName: test.testName,
              testId: test.testId,
            });
          });
        } else {
          // 没有试卷数据的考试，也要显示
          this.paperList.push({
            paperId: null,
            paperType: "暂无试卷",
            paperIndex: null,
            testName: test.testName,
            testId: test.testId,
            isEmpty: true, // 标记为空试卷
          });
        }
      });
    },
    getOrderDisplayName(testOrder) {
      // 根据考试类型显示不同的格式
      if (this.currentTestType && this.currentTestType.testType === 0) {
        // 雅思显示为"剑18"
        return `剑${testOrder}`;
      } else {
        // 四级六级显示为"2023年"
        return `${testOrder}年`;
      }
    },
    // 新增题目相关方法
    addNewQuestion() {
      const newQuestion = {
        questionType: "1", // 默认为单选题
        stem: "",
        paperId: this.currentPaper ? this.currentPaper.paperId : null,
      };

      this.newQuestions.push(newQuestion);
    },
    deleteQuestion(index) {
      this.newQuestions.splice(index, 1);
    },
    submitQuestions() {
      // 防止重复提交
      if (this.isSubmittingQuestions) {
        return;
      }

      if (this.newQuestions.length === 0) {
        this.$message.warning("请至少添加一个题目");
        return;
      }

      // 验证所有题目都有内容
      const emptyQuestions = this.newQuestions.filter((q) => !q.stem.trim());
      if (emptyQuestions.length > 0) {
        this.$message.warning("请填写所有题目的内容");
        return;
      }

      // 提交题目到服务器
      const submitData = this.newQuestions.map((q) => ({
        questionType: parseInt(q.questionType),
        stem: q.stem.trim(),
        paperId: this.currentPaper ? this.currentPaper.paperId : null,
      }));

      // 批量添加题目
      this.batchAddQuestions(submitData);
    },
    async batchAddQuestions(questions) {
      // 设置loading状态
      this.isSubmittingQuestions = true;

      try {
        for (const questionData of questions) {
          const res = await question.addQuestion(questionData);
          if (res.code !== 200) {
            throw new Error(`添加题目失败: ${res.msg}`);
          }
        }

        this.$message.success(`成功添加 ${questions.length} 个题目`);
        this.newQuestions = [];

        // 重新加载题目数据
        if (this.currentPaper && this.currentPaper.paperId) {
          this.reloadQuestionData();
        }
      } catch (error) {
        console.error("批量添加题目失败:", error);
        this.$message.error("添加题目失败，请重试");
      } finally {
        // 无论成功还是失败，都要重置loading状态
        this.isSubmittingQuestions = false;
      }
    },
    cancelQuestions() {
      // 如果正在提交，不允许取消
      if (this.isSubmittingQuestions) {
        return;
      }

      this.newQuestions = [];
    },
    // 编辑解析相关方法
    toggleEditExplanation() {
      // 如果正在保存解析，不允许切换状态
      if (this.isSavingExplanation) {
        return;
      }

      if (this.isEditingExplanation) {
        // 正在编辑时点击，取消编辑
        this.cancelEditExplanation();
      } else {
        // 进入编辑模式
        this.isEditingExplanation = true;
        // 加载当前解析内容到编辑框
        this.editingExplanationText =
          this.getCurrentQuestionExplanation() || "";
      }
    },
    cancelEditExplanation() {
      this.isEditingExplanation = false;
      this.editingExplanationText = "";
      this.isSavingExplanation = false; // 重置保存解析状态
    },
    async saveExplanation() {
      // 防止重复提交
      if (this.isSavingExplanation) {
        return;
      }

      if (!this.selectedQuestionNum || !this.getCurrentQuestion()) {
        this.$message.error("请先选择题目");
        return;
      }

      const currentQuestion = this.getCurrentQuestion();
      const explanationText = this.editingExplanationText.trim();

      // 设置loading状态
      this.isSavingExplanation = true;

      try {
        let answerId = null;
        let answerItem = null;

        // 根据题目类型找到对应的answerId
        if (
          currentQuestion.questionType === 2 ||
          currentQuestion.questionType === 1
        ) {
          // 选择题：找到正确答案项
          answerItem = currentQuestion.answerList.find(
            (item) => item.ifRight === 1
          );
          answerId = answerItem ? answerItem.answerId : null;
        } else if (currentQuestion.questionType === 0) {
          // 填空题：根据题号在填空题中的位置找到对应的答案项
          const questionIndex = this.questionList.findIndex(
            (q) => q.questionId === currentQuestion.questionId
          );
          const questionStartNum = this.getQuestionStartNumber(questionIndex);
          const answerIndex = this.selectedQuestionNum - questionStartNum;

          answerItem = currentQuestion.answerList[answerIndex];
          answerId = answerItem ? answerItem.answerId : null;
        }

        if (!answerId) {
          this.$message.error("找不到对应的答案项");
          return;
        }

        // 调用API更新解析
        const res = await answer.updateAnswer({
          answerId: answerId,
          explain: explanationText,
        });

        if (res.code === 200) {
          // 更新本地数据
          if (answerItem) {
            answerItem.explain = explanationText;
          }

          this.$message.success("解析更新成功");
          this.isEditingExplanation = false;
          this.editingExplanationText = "";
        } else {
          this.$message.error(res.msg || "更新解析失败");
        }
      } catch (error) {
        console.error("更新解析失败:", error);
        this.$message.error("更新解析失败，请重试");
      } finally {
        // 无论成功还是失败，都要重置loading状态
        this.isSavingExplanation = false;
      }
    },
    reloadQuestionData() {
      // 重新加载当前试卷的题目数据
      if (!this.currentPaper || !this.currentPaper.paperId) {
        return;
      }

      question
        .showQuestions(this.currentPaper.paperId)
        .then((res) => {
          if (res.code === 200) {
            console.log("重新加载题目数据:", res.data);
            this.paperDetails = res.data;
            this.questionList = res.data.questionDTOs || [];

            // 更新试卷信息
            this.currentPaper = {
              ...this.currentPaper,
              totalScore: res.data.totalScore,
              setOff: res.data.setOff,
            };

            // 重新选中第一题
            this.selectedQuestionNum = (res.data.setOff || 0) + 1;
          } else {
            console.error("重新加载题目数据失败:", res.msg);
          }
        })
        .catch((error) => {
          console.error("重新加载题目数据失败:", error);
        });
    },
    // 编辑答案相关方法
    openEditAnswerDialog(question) {
      this.editingQuestion = question;
      this.showEditAnswerDialog = true;

      // 深拷贝答案数据用于编辑
      this.editingAnswers = JSON.parse(
        JSON.stringify(question.answerList || [])
      );

      // 确保每个答案都有正确的ifRight值
      this.editingAnswers.forEach((answer) => {
        if (answer.ifRight === undefined) {
          // 填空题默认为正确答案，选择题默认为错误答案
          answer.ifRight = question.questionType === 0 ? 1 : 0;
        } else if (question.questionType === 0) {
          // 填空题强制设置为正确答案
          answer.ifRight = 1;
        }
      });
    },
    closeEditAnswerDialog() {
      this.showEditAnswerDialog = false;
      this.editingQuestion = null;
      this.editingAnswers = [];
      this.isSavingAnswers = false; // 重置保存状态
    },
    async saveAnswers() {
      // 防止重复提交
      if (this.isSavingAnswers) {
        return;
      }

      if (!this.editingQuestion || !this.editingAnswers.length) {
        this.$message.error("没有可保存的答案数据");
        return;
      }

      // 设置loading状态
      this.isSavingAnswers = true;

      try {
        // 验证答案完整性
        const emptyAnswers = this.editingAnswers.filter(
          (a) => !a.answer || !a.answer.trim()
        );
        if (emptyAnswers.length > 0) {
          this.$message.error("请填写所有答案内容");
          return;
        }

        // 准备批量上传数据
        const batchData = {
          questionId: this.editingQuestion.questionId,
          answers: this.editingAnswers.map((answerData, index) => ({
            answer:
              this.editingQuestion.questionType === 0
                ? answerData.answer.trim()
                : `${this.getOptionLabel(index)}. ${answerData.answer.trim()}`,
            ifRight:
              this.editingQuestion.questionType === 0 ? 1 : answerData.ifRight,
            answerIndex: index + 1,
          })),
        };

        // 调用批量上传API
        const res = await answer.addAnswer(batchData);

        if (res.code !== 200) {
          throw new Error(`批量保存答案失败: ${res.msg}`);
        }

        // 更新本地数据
        const questionToUpdate = this.questionList.find(
          (q) => q.questionId === this.editingQuestion.questionId
        );
        if (questionToUpdate) {
          // 如果后端返回了答案列表，使用返回的数据
          if (res.data && res.data.length > 0) {
            questionToUpdate.answerList = res.data;
          } else {
            // 否则使用编辑的数据
            questionToUpdate.answerList = JSON.parse(
              JSON.stringify(this.editingAnswers)
            );
          }

          // 更新rightAnswer字段
          const correctAnswers = this.editingAnswers
            .filter((a) => a.ifRight === 1)
            .map((a) =>
              a.answer.match(/^[A-Z]\./) ? a.answer.charAt(0) : a.answer
            );
          questionToUpdate.rightAnswer = correctAnswers;
        }

        this.$message.success("答案保存成功");
        this.closeEditAnswerDialog();
      } catch (error) {
        console.error("保存答案失败:", error);
        this.$message.error("保存答案失败，请重试");
      } finally {
        // 无论成功还是失败，都要重置loading状态
        this.isSavingAnswers = false;
      }
    },
    addChoiceOption() {
      const newOption = {
        answer: "",
        ifRight: 0,
        answerId: null,
      };
      this.editingAnswers.push(newOption);
    },
    addBlankAnswer() {
      const newAnswer = {
        answer: "",
        ifRight: 1,
        answerId: null,
      };
      this.editingAnswers.push(newAnswer);
    },
    deleteAnswer(index) {
      this.editingAnswers.splice(index, 1);
    },

    // 编辑题目相关方法
    startEditQuestion(question) {
      // 如果正在编辑同一个题目，则取消编辑
      if (this.editingQuestionId === question.questionId) {
        this.cancelEditQuestion();
        return;
      }

      // 开始编辑题目
      this.editingQuestionId = question.questionId;
      this.editingQuestionType = question.questionType.toString();
      this.editingQuestionStem = question.stem; // 保留完整的HTML内容
    },

    cancelEditQuestion() {
      this.editingQuestionId = null;
      this.editingQuestionType = "";
      this.editingQuestionStem = "";
      this.isSavingQuestion = false;
    },

    async saveQuestion(questionId) {
      // 防止重复提交
      if (this.isSavingQuestion) {
        return;
      }

      if (!this.editingQuestionStem.trim()) {
        this.$message.error("请填写题目内容");
        return;
      }

      // 设置loading状态
      this.isSavingQuestion = true;

      try {
        const updateData = {
          questionId: questionId,
          questionType: parseInt(this.editingQuestionType),
          stem: this.editingQuestionStem.trim(),
        };

        const res = await question.updateQuestion(updateData);

        if (res.code === 200) {
          // 更新本地数据
          const questionToUpdate = this.questionList.find(
            (q) => q.questionId === questionId
          );
          if (questionToUpdate) {
            questionToUpdate.questionType = parseInt(this.editingQuestionType);
            questionToUpdate.stem = this.editingQuestionStem.trim();
          }

          this.$message.success("题目更新成功");
          this.cancelEditQuestion();
        } else {
          this.$message.error(res.msg || "更新题目失败");
        }
      } catch (error) {
        console.error("更新题目失败:", error);
        this.$message.error("更新题目失败，请重试");
      } finally {
        // 无论成功还是失败，都要重置loading状态
        this.isSavingQuestion = false;
      }
    },
  },
};
</script>

<style>
.test-page-wrapper {
  height: 100%;
  padding: 20px;
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
}

/* 面包屑导航样式 */
.breadcrumb {
  display: flex;
  align-items: center;
  padding: 12px 0;
  margin-bottom: 20px;
  font-size: 14px;
  background: #fff;
  border-radius: 8px;
  padding: 12px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.breadcrumb-item {
  color: #666;
  font-weight: 600;
}

.breadcrumb-item.clickable {
  color: #2c3e50;
  cursor: pointer;
  transition: color 0.3s ease;
  font-weight: 600;
}

.breadcrumb-item.clickable:hover {
  color: #000;
  text-decoration: underline;
}

.breadcrumb-item.active {
  color: #2c3e50;
  font-weight: 600;
}

.breadcrumb-separator {
  margin: 0 12px;
  color: #999;
  font-weight: normal;
}

/* 编辑答案区域样式 */
.edit-answer-area {
  flex: 1;
  display: flex;
  min-height: 0;
  overflow: hidden;
}

.answer-layout {
  display: flex;
  width: 100%;
  height: 100%;
  gap: 20px;
  padding: 0 0 10px 0; /* 只在底部留出阴影空间 */
  box-sizing: border-box;
}

/* 左侧面板：试卷信息 */
.left-panel {
  flex: 1;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  height: 100%;
  overflow: hidden;
}

/* 中间面板：题号列表 */
.middle-panel {
  width: 180px;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
  height: 100%;
  overflow: hidden;
}

/* 右侧面板：题目详情 */
.right-panel {
  flex: 1;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 0;
  height: 100%;
  overflow: hidden;
}

/* 面板头部样式 */
.panel-header {
  background: linear-gradient(135deg, #ffd700 0%, #ffed4a 100%);
  padding: 16px 20px;
  border-radius: 12px 12px 0 0;
  border-bottom: 1px solid #e6e6e6;
  flex-shrink: 0;
}

.panel-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
}

/* 面板内容样式 */
.panel-content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  min-height: 0;
}

/* 左侧试卷信息样式 */
.paper-info p {
  margin: 12px 0;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.paper-info strong {
  color: #2c3e50;
  font-weight: 600;
}

/* 试卷内容样式 */
.paper-content {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #e6e6e6;
}

.paper-content h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  border-bottom: 2px solid #ffd700;
  padding-bottom: 8px;
}

.stem-content {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.stem-content strong {
  font-weight: 600;
  color: #2c3e50;
}

.stem-content i {
  font-style: italic;
  color: #666;
  margin-bottom: 10px;
  display: block;
}

.stem-content div {
  margin: 10px 0;
}

.stem-content span {
  font-size: 16px;
}

/* 题目项样式 */
.question-item {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
}

.question-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.question-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}

.question-type-badge {
  background: #2c3e50;
  color: #fff;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

/* 中间题号列表样式 */
.question-numbers {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.question-number {
  padding: 10px 16px;
  text-align: center;
  border: 2px solid #e6e6e6;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  color: #666;
  background: #f8f9fa;
}

.question-number:hover {
  border-color: #ffd700;
  background: #fff9c4;
  color: #333;
}

.question-number.active {
  border-color: #ffd700;
  background: #ffd700;
  color: #2c3e50;
  font-weight: 600;
}

/* 右侧题目详情样式 */
.question-detail {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.question-section,
.options-section,
.answer-section,
.explanation-section {
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  padding: 16px;
  background: #f8f9fa;
}

.question-section h4,
.options-section h4,
.answer-section h4,
.explanation-section h4 {
  margin: 0 0 12px 0;
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  border-bottom: 2px solid #ffd700;
  padding-bottom: 8px;
}

.question-content p {
  margin: 8px 0;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

/* 题目内容HTML样式 */
.question-content {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.question-content strong {
  font-weight: 600;
  color: #2c3e50;
}

.question-content i {
  font-style: italic;
  color: #666;
  margin-bottom: 10px;
  display: block;
}

.question-content div {
  margin: 10px 0;
}

.question-content span {
  font-size: 16px;
}

/* 选项样式 */
.options-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.option-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.option-item:hover {
  background: #fff9c4;
  border-color: #ffd700;
}

.option-item.correct {
  background: #e8f5e8;
  border-color: #4caf50;
}

.option-item.correct:hover {
  background: #d4f4d4;
  border-color: #4caf50;
}

.option-label {
  font-weight: 600;
  color: #2c3e50;
  min-width: 20px;
}

.option-text {
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

.correct-mark {
  color: #4caf50;
  font-weight: bold;
  font-size: 16px;
  margin-left: auto;
}

/* 正确答案样式 */
.correct-answer {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #e8f5e8;
  border: 1px solid #4caf50;
  border-radius: 6px;
}

.answer-label {
  font-weight: 600;
  color: #2c3e50;
}

.answer-value {
  font-weight: 600;
  color: #4caf50;
  font-size: 16px;
}

/* 答案列表样式 */
.answers-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.single-answer {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.answer-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 12px;
  background: #e8f5e8;
  border: 1px solid #4caf50;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.answer-item:hover {
  background: #d4f4d4;
}

.answer-number {
  font-weight: 600;
  color: #2c3e50;
  min-width: 30px;
}

.answer-text {
  font-size: 14px;
  color: #2c3e50;
  line-height: 1.5;
  font-weight: 500;
}

/* 解析样式 */
.explanation-content p {
  margin: 8px 0;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.explanation-detail {
  margin-top: 15px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #ffd700;
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.explanation-detail p {
  margin: 8px 0;
}

.explanation-detail br {
  line-height: 1.8;
}

.explanation-detail strong {
  font-weight: 600;
  color: #2c3e50;
}

.no-explanation {
  margin-top: 15px;
  padding: 15px;
  background: #f1f1f1;
  border-radius: 8px;
  text-align: center;
  color: #666;
  font-style: italic;
}

/* 编辑解析样式 */
.explanation-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.explanation-header h4 {
  margin: 0;
}

.edit-explanation-btn {
  background: #ffd700;
  color: #000;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.edit-explanation-btn:hover {
  background: #e6c200;
}

.edit-explanation-btn:disabled {
  background: #ccc;
  color: #888;
  cursor: not-allowed;
  opacity: 0.6;
}

.edit-explanation-btn:disabled:hover {
  background: #ccc;
}

.explanation-edit {
  margin-top: 15px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid #ffd700;
}

.edit-label {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  font-size: 14px;
}

.explanation-textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  resize: vertical;
  min-height: 120px;
  font-family: inherit;
  line-height: 1.5;
  box-sizing: border-box;
  margin-bottom: 12px;
}

.explanation-textarea:focus {
  outline: none;
  border-color: #ffd700;
}

.edit-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.save-explanation-btn {
  background: #ffd700;
  color: #000;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.save-explanation-btn:hover {
  background: #e6c200;
}

.save-explanation-btn:disabled {
  background: #ccc;
  color: #888;
  cursor: not-allowed;
  opacity: 0.6;
}

.save-explanation-btn:disabled:hover {
  background: #ccc;
}

.cancel-explanation-btn {
  background: #6c757d;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.cancel-explanation-btn:hover {
  background: #5a6268;
}

/* 未选择题目提示 */
.no-question-selected {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  text-align: center;
  color: #999;
  font-size: 16px;
}

/* 滚动条样式 */
.panel-content::-webkit-scrollbar {
  width: 6px;
}

.panel-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.panel-content::-webkit-scrollbar-thumb {
  background: #ffd700;
  border-radius: 3px;
}

.panel-content::-webkit-scrollbar-thumb:hover {
  background: #e6c200;
}

/* 确保滚动容器高度正确 */
#test {
  min-height: 0;
}

/* 添加题目表格样式 */
.add-questions-section {
  padding: 20px;
  background: #f9f9f9;
  border-radius: 8px;
  margin-top: 20px;
}

.add-questions-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 30px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
}

.add-questions-header h4 {
  margin: 0;
  color: #2c3e50;
  font-size: 16px;
  font-weight: 600;
}

.add-question-btn {
  background: #ffd700;
  color: #000;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.add-question-btn:hover {
  background: #e6c200;
  transform: translateY(-1px);
}

.questions-table {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.question-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e9ecef;
}

.question-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.question-type-buttons {
  display: flex;
  gap: 10px;
}

.type-btn {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  color: #666;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.type-btn:hover {
  background: #fff1c1;
  border-color: #ffd700;
  color: #333;
}

.type-btn.active {
  background: #ffd700;
  color: #000;
  border-color: #ffd700;
  font-weight: 600;
}

.question-content {
  margin-top: 15px;
}

.question-content-wrapper {
  margin-top: 15px;
}

.content-label {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  font-size: 14px;
}

.stem-input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  resize: vertical;
  min-height: 80px;
  font-family: inherit;
  line-height: 1.5;
  box-sizing: border-box;
}

.stem-input:focus {
  outline: none;
  border-color: #ffd700;
}

.delete-btn {
  background: #ff6b6b;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.delete-btn:hover {
  background: #ff5252;
  transform: translateY(-1px);
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: #666;
  font-size: 14px;
}

.submit-section {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
}

.submit-btn {
  background: #ffd700;
  color: #000;
  border: none;
  padding: 10px 30px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.submit-btn:hover {
  background: #e6c200;
}

.submit-btn:disabled {
  background: #ccc;
  color: #888;
  cursor: not-allowed;
  opacity: 0.6;
}

.submit-btn:disabled:hover {
  background: #ccc;
}

.cancel-btn {
  background: #6c757d;
  color: #fff;
  border: none;
  padding: 10px 30px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.cancel-btn:hover {
  background: #5a6268;
}

/* 主要内容区域样式 */
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

#testChoice {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 0;
  padding: 10px;
  background: #fff;
  border-radius: 10px;
  flex-shrink: 0;
}

/* Tab样式 - 考试类型选择 */
.tab-container {
  display: flex;
  gap: 20px;
  padding-bottom: 0;
  margin-bottom: 0;
}

.tab-item {
  padding: 8px 8px;
  border: none;
  border-radius: 0;
  background: transparent;
  color: #666;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  border-bottom: 3px solid transparent;
}

.tab-item:hover {
  color: #e6b800;
  background: transparent;
}

.tab-item.active {
  color: #ffd700;
  background: transparent;
  border-bottom: 3px solid #ffd700;
  font-weight: 600;
}

/* 第二行testOrder tabs样式 */
.order-tabs-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.order-tabs {
  margin: 0;
  padding: 0;
  justify-content: flex-start;
  flex-shrink: 0;
  border-bottom: none;
  gap: 8px;
  flex: 1;
}

.order-tabs .tab-item {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  color: #666;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.order-tabs .tab-item:hover {
  background: #fff1c1;
  border-color: #ffd700;
  color: #333;
}

.order-tabs .tab-item.active {
  background: #ffd700;
  color: #000;
  border-color: #ffd700;
  font-weight: 600;
}

/* 按钮行样式 */
.button-row {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.test-button {
  padding: 8px 16px;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  background-color: #fff;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
}

.test-button:hover {
  background-color: #f5f7fa;
  border-color: #c0c4cc;
}

.test-button.active {
  color: #1890ff;
  border-color: #badeff;
  background-color: #e8f4ff;
}

/* 主按钮样式 */
.primary-button {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background-color: #2c3e50;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
  font-weight: 500;
}

.primary-button:hover {
  background-color: #34495e;
}

.primary-button:active {
  background-color: #1a252f;
}

/* 表格样式 */
#test {
  margin-top: 20px;
  /* margin-bottom: 60px; */
  flex: 1;
  overflow-y: auto;
  padding-bottom: 20px;
  min-height: 0; /* 确保flex子元素能够滚动 */
}

/* 滚动条样式 - 隐藏滚动条 */
#test::-webkit-scrollbar {
  display: none;
}

#test {
  -ms-overflow-style: none; /* IE和Edge */
  scrollbar-width: none; /* Firefox */
}

/* 考试分组样式 */
.test-group {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 20px;
  overflow: hidden;
}

.test-group:last-child {
  margin-bottom: 0;
}

.test-group-header {
  background: linear-gradient(135deg, #ffd700 0%, #ffed4a 100%);
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.test-group-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 8px;
}

.test-group-header h3::before {
  content: "📝";
  font-size: 16px;
}

.paper-count {
  background: #ff6b35;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

/* 当没有数据时的提示 */
.no-data {
  text-align: center;
  padding: 40px;
  color: #999;
  font-size: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.no-data::before {
  content: "📝";
  font-size: 24px;
  display: block;
  margin-bottom: 10px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  margin: 0;
}

.data-table th,
.data-table td {
  padding: 12px 15px;
  text-align: left;
}

.data-table th {
  background-color: #fff9c4;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.data-table tbody tr:hover {
  background-color: #fff9c4;
}

.data-table tbody tr:last-child td {
  border-bottom: none;
}

/* 分组内表格的特殊样式 */
.test-group .data-table {
  border-radius: 0;
  box-shadow: none;
}

.test-group .data-table th:first-child {
  padding-left: 20px;
}

.test-group .data-table td:first-child {
  padding-left: 20px;
}

.test-group .data-table th:last-child,
.test-group .data-table td:last-child {
  padding-right: 20px;
}

/* 编辑按钮样式 */
.edit-button {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  background-color: #409eff;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
}

.edit-button:hover {
  background-color: #337ecc;
}

.edit-button:active {
  background-color: #2a6cb8;
}

/* 图标按钮样式 */
.icon-button {
  padding: 6px;
  border: 1px solid #e6c200;
  border-radius: 6px;
  background-color: #ffd700;
  cursor: pointer;
  outline: none;
  margin: 0 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  font-size: 20px;
}

.icon-button img {
  width: 16px;
  height: 16px;
  display: block;
}

/* 添加试卷按钮样式 */
.add-button {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  background-color: #67c23a;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
}

.add-button:hover {
  background-color: #5daf34;
}

.add-button:active {
  background-color: #529b2e;
}

/* 空试卷文本样式 */
.empty-paper {
  color: #909399;
  font-style: italic;
}

/* 响应式设计 */
@media (max-width: 768px) {
  #testChoice {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
    padding: 15px;
    margin-bottom: 0;
  }

  .tab-container {
    justify-content: center;
    gap: 15px;
    margin-bottom: 20px;
  }

  .tab-item {
    padding: 10px 8px;
    font-size: 13px;
  }

  .order-tabs .tab-item {
    padding: 6px 12px;
    font-size: 12px;
  }

  .button-row {
    justify-content: center;
  }

  .data-table {
    font-size: 12px;
  }

  .data-table th,
  .data-table td {
    padding: 8px 10px;
  }

  .test-group-header h3 {
    font-size: 16px;
  }

  .test-group {
    margin-bottom: 15px;
  }

  .test-group-header {
    padding: 12px 15px;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }

  .header-left {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .header-right {
    width: 100%;
    justify-content: flex-end;
    margin-top: 8px;
  }

  .primary-button {
    padding: 6px 12px;
    font-size: 12px;
  }

  .paper-count {
    font-size: 11px;
    padding: 3px 8px;
  }

  .order-tabs-wrapper {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }

  .order-tabs {
    margin: 0;
    padding: 0;
    gap: 6px;
  }

  .order-tabs-wrapper .header-right {
    width: 100%;
    justify-content: center;
  }

  .order-tabs .tab-item {
    padding: 6px 10px;
    font-size: 11px;
  }

  /* 编辑答案区域移动端样式 */
  .answer-layout {
    flex-direction: column;
    gap: 15px;
    height: calc(100vh - 100px);
    overflow-y: auto;
  }

  .left-panel,
  .middle-panel {
    width: 100%;
    height: 220px;
    overflow: hidden;
  }

  .middle-panel .panel-content {
    height: 160px;
    overflow-y: auto;
  }

  .right-panel {
    height: 350px;
    overflow: hidden;
  }

  .panel-header {
    padding: 12px 15px;
  }

  .panel-header h3 {
    font-size: 14px;
  }

  .panel-content {
    padding: 15px;
  }

  .question-numbers {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 6px;
  }

  .question-number {
    padding: 8px 4px;
    font-size: 12px;
  }

  .question-detail {
    gap: 16px;
  }

  .question-section,
  .options-section,
  .answer-section,
  .explanation-section {
    padding: 12px;
  }

  .question-section h4,
  .options-section h4,
  .answer-section h4,
  .explanation-section h4 {
    font-size: 13px;
  }

  .question-content p,
  .explanation-content p {
    font-size: 13px;
  }

  .option-item {
    padding: 6px 10px;
  }

  .option-text {
    font-size: 13px;
  }

  .paper-info p {
    font-size: 13px;
  }

  /* 移动端题目项样式 */
  .question-item {
    margin-bottom: 20px;
    padding-bottom: 15px;
  }

  .question-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
  }

  .question-title {
    font-size: 13px;
  }

  .question-type-badge {
    font-size: 11px;
    padding: 1px 6px;
  }
}

.edit-answer-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.edit-answer-dialog {
  background: white;
  border-radius: 12px;
  width: 750px;
  max-width: 95vw;
  max-height: 85vh;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background: #ffd700;
  border-radius: 12px 12px 0 0;
  flex-shrink: 0;
}

.dialog-header h3 {
  margin: 0;
  color: #000;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #000;
  padding: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.1);
}

.dialog-content {
  padding: 20px;
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.question-info {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  flex-shrink: 0;
}

.question-info p {
  margin: 5px 0;
  color: #666;
}

/* 题目内容显示样式 */
.question-stem-display {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  flex-shrink: 0;
}

.stem-header {
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #ffd700;
}

.stem-header h4 {
  margin: 0;
  color: #2c3e50;
  font-weight: 600;
  font-size: 14px;
}

.stem-content-display {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
  max-height: 150px;
  overflow-y: auto;
  padding: 8px 0;
}

.stem-content-display strong {
  font-weight: 600;
  color: #2c3e50;
}

.stem-content-display i {
  font-style: italic;
  color: #666;
}

/* 题目内容显示区域的滚动条 */
.stem-content-display::-webkit-scrollbar {
  width: 6px;
}

.stem-content-display::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.stem-content-display::-webkit-scrollbar-thumb {
  background: #ffd700;
  border-radius: 3px;
}

.stem-content-display::-webkit-scrollbar-thumb:hover {
  background: #e6c200;
}

/* 选择题和填空题容器 - 添加滚动 */
.choice-edit,
.blank-edit {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.choice-options,
.blank-answers {
  flex: 1;
  overflow-y: auto;
  max-height: 400px;
  padding-right: 8px;
}

/* 滚动条样式 */
.choice-options::-webkit-scrollbar,
.blank-answers::-webkit-scrollbar {
  width: 6px;
}

.choice-options::-webkit-scrollbar-track,
.blank-answers::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.choice-options::-webkit-scrollbar-thumb,
.blank-answers::-webkit-scrollbar-thumb {
  background: #ffd700;
  border-radius: 3px;
}

.choice-options::-webkit-scrollbar-thumb:hover,
.blank-answers::-webkit-scrollbar-thumb:hover {
  background: #e6c200;
}

.dialog-actions {
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  flex-shrink: 0;
}

.save-btn {
  background: #ffd700;
  color: #000;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  margin: 0;
}

.save-btn:hover {
  background: #e6c200;
}

.save-btn:disabled {
  background: #ccc;
  color: #888;
  cursor: not-allowed;
  opacity: 0.6;
}

.save-btn:disabled:hover {
  background: #ccc;
}

.cancel-btn {
  background: #f5f5f5;
  color: #666;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s ease;
  margin: 0;
}

.cancel-btn:hover {
  background: #e0e0e0;
}

.cancel-btn:disabled {
  background: #f5f5f5;
  color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

.cancel-btn:disabled:hover {
  background: #f5f5f5;
}

/* 新增题目相关样式 */
.add-questions-header {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  margin-top: 20px;
  border-top: 2px solid #f0f0f0;
}

.add-question-btn {
  background: #ffd700;
  color: #000;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.add-question-btn:hover {
  background: #e6c200;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* 左侧面板按钮样式 */
.question-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.edit-question-btn {
  background: #ffd700;
  color: #000;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.edit-question-btn:hover {
  background: #e6c200;
  transform: translateY(-1px);
}

.edit-question-btn:disabled {
  background: #ccc;
  color: #888;
  cursor: not-allowed;
  transform: none;
}

.edit-answer-btn {
  background: #ffd700;
  color: #000;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.edit-answer-btn:hover {
  background: #e6c200;
  transform: translateY(-1px);
}

/* 删除按钮 */
.delete-answer-btn {
  width: 36px;
  height: 36px;
  background: #ff6b6b;
  color: #fff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.delete-answer-btn:hover {
  background: #ff5252;
  transform: scale(1.1);
}

.delete-answer-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
}

.delete-answer-btn:disabled:hover {
  background: #ccc;
  transform: none;
}

/* 选择题和填空题容器 */
.choice-options,
.blank-answers {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.choice-option,
.blank-answer {
  border: none;
  border-radius: 0;
  padding: 0;
  background: transparent;
  margin-bottom: 0;
}

/* 编辑答案弹窗新布局样式 */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f0f0;
}

.section-header h4 {
  margin: 0;
  color: #333;
  font-weight: 600;
  font-size: 16px;
}

.add-answer-btn {
  background: #ffd700;
  color: #000;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.add-answer-btn:hover {
  background: #e6c200;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* 选择题和填空题的行布局样式 */
.option-row,
.answer-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-bottom: 12px;
  transition: all 0.3s ease;
}

.option-row:hover,
.answer-row:hover {
  border-color: #ffd700;
  box-shadow: 0 2px 8px rgba(255, 215, 0, 0.2);
}

/* 标签容器 */
.option-label-container,
.answer-label-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: #ffd700;
  border-radius: 50%;
  flex-shrink: 0;
}

.option-label,
.answer-label {
  font-weight: 700;
  color: #000;
  font-size: 16px;
  text-align: center;
}

/* 输入框容器 */
.option-input-container,
.answer-input-container {
  flex: 1;
  margin: 0 8px;
}

.option-input,
.answer-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.option-input:focus,
.answer-input:focus {
  outline: none;
  border-color: #ffd700;
  box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.2);
}

/* 控制按钮容器 */
.option-controls,
.answer-controls {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.option-controls {
  min-width: 120px;
}

.answer-controls {
  min-width: 50px;
}

/* 正确答案复选框 */
.correct-checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 6px;
  transition: background-color 0.3s ease;
}

.correct-checkbox:hover {
  background: #f8f9fa;
}

.correct-checkbox input[type="checkbox"] {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
}

.checkbox-label {
  font-size: 13px;
  color: #666;
  font-weight: 500;
  white-space: nowrap;
}

/* 选择题和填空题容器样式重置 */
.choice-option,
.blank-answer {
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
}

/* 编辑题目样式 */
.edit-question-section {
  background: #f8f9fa;
  border: 2px solid #ffd700;
  border-radius: 8px;
  padding: 20px;
  margin-top: 15px;
}

.edit-question-header {
  margin-bottom: 15px;
  padding-bottom: 8px;
}

.edit-question-header h4 {
  margin: 0;
  color: #2c3e50;
  font-weight: 600;
  border-bottom: 2px solid #ffd700;
  padding-bottom: 8px;
}

.edit-question-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.question-type-edit {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.question-type-edit label {
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
}

.question-content-edit {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.question-content-edit label {
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
}

.stem-edit-input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  resize: vertical;
  min-height: 120px;
  font-family: inherit;
  line-height: 1.5;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

.stem-edit-input:focus {
  outline: none;
  border-color: #ffd700;
}

.edit-question-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.save-question-btn {
  background: #ffd700;
  color: #000;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.save-question-btn:hover {
  background: #e6c200;
}

.save-question-btn:disabled {
  background: #ccc;
  color: #888;
  cursor: not-allowed;
  opacity: 0.6;
}

.cancel-edit-btn {
  background: #6c757d;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.cancel-edit-btn:hover {
  background: #5a6268;
}

.cancel-edit-btn:disabled {
  background: #ccc;
  color: #888;
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
